// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__1truz","bigColWidth":"Table_bigColWidth__Lv9Ud","biggerColWidth":"Table_biggerColWidth__3hTX6","row":"Table_row__1fNBS","col":"Table_col__3tfYh"};